<template>
	<!-- :class="node.class"  -->
	<div
		class="row"
		v-bind:class="[
			{
				'row-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:style="getRowStyle(node)">

		<NodeAction :node="node" component="row" v-if="!onPreview" />

		<template v-if="node.children && node.children.length > 0">
			<!-- <ColumnResize class="resize d-flex" :active="['r', 'l']"> -->
				<NodeTree
					v-for="(child, i) in node.children"
					:node="child"
					:key="i"
					:onPreview="onPreview"
					:previewDevice.sync="previewDevice"
					:settings="settings"
				/>

				<!-- <NodeResize /> -->
			<!-- </ColumnResize> -->
		</template>
		<template v-else>
			<div
				class="column-empty-view"
				v-tooltip="'Add New Row'"
			>
				<!-- @click="onChangePanel" -->
				<div class="column-empty-view__first-add">
					<i class="material-icons d-block">add</i>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// import ColumnResize from '@/components/funnels/pagebuilder/parts/ColumnResize.vue';
// import NodeResize from '@/components/funnels/pagebuilder/nodes/NodeResize.vue';
import {
	getNodeStyle,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeRow',
	props: ['node', 'onPreview', 'mainNode', 'previewDevice', 'settings'],
	components: {
		NodeAction,
		// NodeResize,
		// ColumnResize,
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			pageHistories: 'funnels/pageHistories',
		}),
	},
	methods: {
		...mapActions({
			setPageEditorHistory: 'funnels/setPageEditorHistory',
		}),
		getRowStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'padding',
				'margin',
				'font-family',
				'font-size',
				'bg-color',
				'border',
				'bg-img',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
	},
};
</script>

<style lang="scss">
.row-add-column {
	position: absolute;
	background: #fff;
	width: 320px;
	right: 0;
	transform: translate(-50%, -50%);
	padding: 10px;
	top: 100%;

	.new-section-column {
		div {
			max-width: 120px;
		}
	}
}

// .row-handle {
// 	cursor: all-scroll !important;
// }

.moving-row {
	// @apply opacity-50 bg-gray-100 border border-blue-500;
	background: #fff;
	border: 1px solid #ddd;
	height: 60px;
	width: 120px;
}
</style>
